import { Box, Typography, useTheme } from '@mui/material'

export function Copyright(): React.ReactElement {

  const theme = useTheme()

  return (
    <Box sx={{
      mt: '2rem',
      mb: '2rem',
      color: theme.palette.grey[800],
      fontWeight: 400,
      fontSize: '0.625rem',
      textAlign: 'center',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase'
    }}>
      <Typography>©Enion</Typography>
    </Box>
  )
}
